import { render, staticRenderFns } from "./ChannelConfirmation.vue?vue&type=template&id=55ea52a1&scoped=true&"
import script from "./ChannelConfirmation.vue?vue&type=script&lang=js&"
export * from "./ChannelConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ea52a1",
  null
  
)

export default component.exports